import StackedBar from 'd3vue/components/StackedBar.vue'
import { keepDimensions, buildCropFunction, valueAsNumber } from '../dataFilter'
import { toScale } from '../colors'
import api from '../api'

export default {
  id: 'stacked-bar',
  label: 'Graphique en barre empilées',
  component: StackedBar,
  dimensions: 2,
  multipleMeasure: () => false,
  adaptater: (data, vue) => {
    const result = []
    const groups = {}
    const keys = []
    keepDimensions(2, data).forEach(d => {
      if (typeof d.Group1Caption !== 'undefined' && keys.indexOf(d.Group1Caption) === -1) {
        keys.push(d.Group1Caption)
      }
      if (vue.noEmpty && !d[api.measure.name(vue.measure[0])]) {
        return
      }
      if (typeof groups[d.Group0Caption] === 'undefined') {
        groups[d.Group0Caption] = {
          data: d,
          x: d.Group0Caption,
          y: 0
        }
        result.push(groups[d.Group0Caption])
      }
      const value = valueAsNumber(d[api.measure.name(vue.measure[0])])
      groups[d.Group0Caption].y += value
      if (typeof d.Group1Caption !== 'undefined') {
        groups[d.Group0Caption][d.Group1Caption] = value
      }
    })
    const props = {
      keys: keys
    }
    if (vue.colorScheme) {
      props.colorScale = toScale(vue.colorScheme)
    }
    vue.buildProps(props)
    result.forEach(d => {
      keys.forEach(k => {
        if (typeof d[k] === 'undefined') {
          d[k] = 0
        }
      })
    })
    return buildCropFunction(d => keys.map(k => d[k]).reduce((a, v) => a + v), vue)(result)
  },
  multipleGraphHandler (result, properties, vue) {
    let min = null
    let max = null
    result.forEach(data => {
      data.data.forEach(d => {
        if (min === null || min > d.y) {
          min = d.y
        }
        if (max === null || max < d.y) {
          max = d.y
        }
      })
    })
    result.forEach(data => {
      Object.assign(data.props, { min, max }, properties)
    })
  }
}



// WEBPACK FOOTER //
// ./node_modules/macarons-graphs-front/src/graph/StackedBar.js